// Module
var code = `<div class="oe-selector" style="{{>visibility}}">
    <terceraLabel text="{{label}}" visible="{{visible}}" />

    <div class="oe-selector-right">
        <accountSelector visible="{{.visible}}" enabled="{{enabled}}" selectedItem="{{account}}"/>
    </div>
</div>`;
// Exports
export default code;